module.exports = ["Самарская область","Воронежская область","Кемеровская область","Ульяновская область","Ростовская область","Ярославская область","Москва и Московская область","Нижегородская область","Волгоградская область","Краснодарский край","Липецкая область","Тульская область","Пензенская область","Рязанская область","Ставропольский край","Смоленская область","Вологодская область","Тамбовская область","Ленинградская область","Новосибирская область","Республика Марий Эл","Саратовская область","Республика Карелия","Свердловская область","Астраханская область","Калужская область","Челябинская область"]


//////////////////
// WEBPACK FOOTER
// ./src/data/regions.json
// module id = 153
// module chunks = 0